import { ILogger, LogLevel } from "@microsoft/signalr";

import { EnumHelper } from "@/Common/Helpers/EnumHelper";

/** Console logger for SignalR adding prefix and min level. */
class SignalRLogger implements ILogger {
    private readonly minLevel: LogLevel;

    constructor(minimumLogLevel: LogLevel) {
        this.minLevel = minimumLogLevel;
    }

    public log(logLevel: LogLevel, message: string): void {
        if (logLevel >= this.minLevel || globalThis.enableSignalRLogs) {
            const msg = `[SignalR ${EnumHelper.getName(LogLevel, logLevel)}] ${message}`;
            switch (logLevel) {
                case LogLevel.Critical:
                case LogLevel.Error:
                    console.error(msg);
                    break;
                case LogLevel.Warning:
                    console.warn(msg);
                    break;
                case LogLevel.Information:
                    console.info(msg);
                    break;
                default:
                    console.debug(msg);
                    break;
            }
        }
    }
}

export { SignalRLogger };
